function toLatLng(coord) {
  return coord;
}
function toLngLat(coord) {
  return [coord[1], coord[0]];
}

// // Build OSRM route URL
// https://project-osrm.org/docs/v5.24.0/api/#
// https://project-osrm.org/docs/v5.24.0/api/?language=JavaScript#
function buildOSRMUrl(coords) {
  const coordStr = coords
    .map(toLngLat)
    .map((c) => c.join(","))
    .join(";");
  //   // Use the demo server (for production, host your own)
  return `https://router.project-osrm.org/route/v1/driving/${coordStr}?overview=full&geometries=geojson`;
}

export default buildOSRMUrl;
